import { Box, Button, Container, Typography } from '@mui/material'
import NotificationSys from 'components/NotificationSystem'
import { useQuery } from 'react-query'
import { unsubscribeEmail } from 'api/profile'
import { useSearchParamsObject } from 'utils/url'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { AuthCopyright } from '../AuthCopyright/AuthCopyright'

export const AuthPageUnsubscribeEmail = () => {
  const { token } = useSearchParamsObject()
  const navigate = useNavigate()

  const hasToken = typeof token === 'string' && token.trim().length > 0

  const { isLoading, isSuccess, isError } = useQuery(
    ['unsubscribeEmail', token],
    () => unsubscribeEmail(token),
    {
      enabled: hasToken,
      retry: false,
      onSuccess: () => {
        NotificationSys.showSuccess(`Email unsubscribed successfully`)
      },
    },
  )

  const showError = !hasToken || isError

  const handleGoToHome = () => {
    navigate(routes.signIn)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        flex={1}
      >
        {hasToken && isLoading && <LoadingPlaceholder />}

        {hasToken && isSuccess && (
          <>
            <Typography variant="h5" textAlign="center" color="success.main" mb={3}>
              You have been successfully unsubscribed from email notifications.
            </Typography>
            <Button variant="contained" onClick={handleGoToHome} sx={{ minWidth: 160 }}>
              Go to Home
            </Button>
          </>
        )}

        {showError && (
          <>
            <Typography variant="h5" textAlign="center" color="error.main" mb={3}>
              Failed to unsubscribe. Please try again or contact support.
            </Typography>
            <Button variant="contained" onClick={handleGoToHome} sx={{ minWidth: 160 }}>
              Go to Home
            </Button>
          </>
        )}
      </Box>

      <Box mt="auto" mb={3}>
        <AuthCopyright />
      </Box>
    </Box>
  )
}
